import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const RichTextEditorContainer = styled.div`
  font-family: ${theme.fonts.Medium};
  font-size: 14px;
  color: ${theme.colours.blackText};
  background-color: ${theme.colours.white};

  /* padding: 8px 12px; */
  border: 1px solid rgb(200, 200, 200);
  border-radius: 8px;
  text-align: none !important;

  min-height: 90px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .ProseMirror-focused {
    outline: none !important;
  }

  .ProseMirror * {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  div[name='description'] {
    padding: 2px 12px !important;
  }

  .ProseMirror p.is-editor-empty:first-child::before {
    color: #adb5bd;
    content: attr(data-placeholder);
    float: right;
    height: 0;
    pointer-events: none;
  }

  .ProseMirror {
    padding-left: 8px;
    padding-right: 8px;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
    
    ul,
    ol {
      padding-inline-start: 12px;
    }

    li {
      position: relative;
    }

    /* Ensure bold and underline work together */
    strong, .bold-text {
      font-weight: bold !important;
    }

    u, .underline-text {
      text-decoration: underline !important;
    }

    /* Combined bold and underline */
    strong u, u strong, .bold-text.underline-text, .underline-text.bold-text {
      font-weight: bold !important;
      text-decoration: underline !important;
    }
  }
`;

export const ToolbarContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-start !important;
  margin-bottom: 8px;
  border-bottom: 1px solid rgb(200, 200, 200);
  padding: 8px 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  button {
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    border-radius: 4px;
    transition: background-color 100ms ease;
    color: ${theme.colours.blackText} !important;
    height: 18px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;

    &.separator {
      color: ${theme.colours.BrightGray3} !important;
      cursor: default;
    }

    &.is-active,
    &:hover {
      font-weight: 600;
      background-color: ${theme.colours.BrightGray3};
      padding: 2px;
    }

    .mantine-Button-label {
      height: unset !important;
    }

  }
`;

